var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 27,
    viewBox: "0 0 32 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 27,
    fill: "url(#pattern0_2554_452)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2554_452",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2554_452",
    transform: "scale(0.03125 0.037037)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2554_452",
    width: 32,
    height: 27,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAbCAYAAAAdx42aAAAFDUlEQVRIDZVXS4tcRRRuq6ozj1SdO897zu3pJJNxRBxwIQOiIDLoKpu4CPEXuHCh4CJoRCGDz4ULXelGcCMIuhJciOBaXJiFJJEY8+o4Y8TExDw0yfRMy1e3TnOnnelpB4rqetw63/nOd07V1Dqdzn1Ztnd8dGpfMTLR2DOc7Z0bndrTQPMi0yHMTI6NzY6NTDZnhjPevzvfz545x158o3u364eoOQ8btVqtdvjwYYsef/Pz80MTE/NUq2fF847ktA1yyQb+zZK0bOAVS3zWkly0JBcs8Zk0v2pJzse5uEdaxueXjM9Xtm/cMp5/tJk8C6MwXgVSs8S3bOBOam0beKMy1vlte+PzjR1ax/i8YzyfaDQaowsLC7tKDhIQG3h9G4O98xjfS00BrRmfo633aQlAvopwwjhCMjs7OxyBlMblbhcEGCH+1AX+NrFTBdLLkHqvRvr1x0NoTMEoM+9eXFysRzYSgH9Kz+QPS3IAm5aWlpwNjYOW5M8uuC3C04d+gAHAdeP5jvHcQghwtmogirMS8zVL8sny8rKJ1CQQLshPNsjfFaYQhjUbGGy0KwD6eQ8NtKamHgzqHByMdtJBiGnbkXw1Pj6XYUFTx5Ect0HAEPZAoDCMsAAEPNzBcFzfMIHPKQPqoAKARzh8PXqaFYew0Gw2R1yQI2lN9ygIGMfvRDPf3QyEb28e5xsm5Ge3A6CHlulHfMsFOVnWhmgEHicAUayappGJHkPIiCojylBfBhRA9CoZvmwDr8bCFORO9JbkNsZpfTXpYsN4Pmk9f249f2Z9/rXxfLEUXQSC9CxZ6hOCSGWidCU0GlMovUTNiV3jzYfLLJC7juQY5kEjSrEL8oXLitewDxVONYPSawN//B8m+gBIlMII/4zDNBOGsj3328iA3KkTv9hVbq1Wc2HmceSy6kUBYIy7xfj8h5QhOzKAWJYskJyH+BTAyMRM0xJfg+JdkJdxOLIEQFBE0IMVfIO16p8heaHCwo4a0DD8Cgb0wOGxYl9KuzboVi9RSADSZfKeCflpG/g7l/HTWmDQO188aXw3O/oCaNtSYOsuyCl4poaGqPmAJbkaGcj4KOaVnVglK3UAIHQN/XDGcybwlUFEeC/V/LYLckIvCRjD28AGuYIa4TJ5BQcrOEeyXIZOUAPg4SllDnvwVjA+vzwIANAfLxykmJZLxBOPEEt8HRVPNaBxdsRvJu1AQ8j3y7unZ0XXvZdp4/PV/wXAEv8yPb3g9RC8gBIAsHNE59G7ULyTAJRFiuQCBAmWIE68kEzIrw8KIB6CNKyWyyjCMgvW61S8pABgoAuA+GYEQtLCE073xBCE/NqgABCCDYQA7zSNdQoB0rADAKryCIDkjcRAGUKS8yhKABD1MyazZkAAiGF5uRCfUw0gG3ZNFg+lEHRcxq8qgBgCkmMVAACxgm8BDmKMxSjw1UEZSPfAliGIb0YXineV3h4AsZKCPRQpzRKwZzz/PiCAeMshDPfqGT/nqHjdgWKSj8pSzB0X+EtH/IEl+RBsOJLvU/bEW9ES/+WI33KB33YZH3XE71viGwlAG5cU9KVp3nVGK13qtSJW++7d30M59sD7aqt+h9/xW+NzAGghw8rMkgM28MF6ViziWX4jHRxrwRZGtptXAL1GtxybkJ+BSOvEj9nAz1hfHHKh8UQt/vOhl1HZp9sxXVCb17Y8fAvQvfvWHPE3EHGd5FHnZcll/FR9rPHIv+n/zCoi/4JPAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.1b866694a84de53eed76f16fe8f7d7d4.svg";
export { ForwardRef as ReactComponent };